import { LinkButton } from '../components/Button'
import { FeaturedIcon } from '../components/FeaturedIcon'
import { IconSearch } from '../components/icons'
import { useDocumentTitle } from '../lib/hooks'

/**
 * The page for an address nothing answers. Drawn as an empty state with its
 * icon in the rings, the way every other empty screen in the console is, and
 * one way forward.
 */
export default function NotFound() {
  useDocumentTitle('Page not found')
  return (
    <div className="mx-auto flex max-w-lg flex-col items-center space-y-4 py-20 text-center">
      <FeaturedIcon icon={<IconSearch />} variant="outline-square" size="lg" rings />
      <p className="pt-2 text-sm font-semibold text-accent-text">Nothing here</p>
      <h1 className="text-3xl font-semibold text-ink">That page does not exist</h1>
      <p className="text-base text-ink-muted">
        The link may be out of date, or the thing it pointed at may belong to a different brand. Check
        the brand selected at the top of the screen, or head back to the inbox.
      </p>
      <div className="flex justify-center gap-3 pt-4">
        <LinkButton to="/inbox" variant="primary" size="lg">
          Go to the inbox
        </LinkButton>
      </div>
    </div>
  )
}
